import { render, staticRenderFns } from "./addSplashscreen.vue?vue&type=template&id=7482bd63&"
import script from "./addSplashscreen.vue?vue&type=script&lang=js&"
export * from "./addSplashscreen.vue?vue&type=script&lang=js&"
import style0 from "./addSplashscreen.vue?vue&type=style&index=0&id=7482bd63&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports